<template>
<div>
  <div class="background-image-dashboard"
      :style="[ company && company.loginImage ? {'backgroundImage': 'url(' + company.loginImage + ') center no-repeat'} : {'backgroundImage': 'url(img/temp/cook.jpg)'}]">
    </div>
    <!-- /.background-image-dashboard -->
    <b-container fluid class="d-flex align-items-center pt-6 pb-6">
      <b-row>
        <b-col lg="12">
          <h1 class="display-2 text-white"><span v-if="!this.admin" class="plain">Hello </span><span v-else  class="plain" >Editing </span>{{ user.userName }}</h1>
          <p v-if="!this.admin" class="text-white mt-0 mb-5">This is your profile page. <br/>You can view and update your profile information here.</p>
        </b-col>
        <b-col lg="12" v-if="error">
          <h1>There was an error retrieving data.</h1>
        </b-col>
      </b-row>
    </b-container>

    <!--Charts-->
    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="4" class="order-xl-2" v-if="company">
          <user-card
          :user="user"
          :company='company.company.name'
        ></user-card>
        </b-col>
        <b-col xl="8" class="order-xl-1">
          <edit-profile-form :user="user" apiPath="update"></edit-profile-form>
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>
<script>
  import EditProfileForm from './UserProfile/EditProfileForm.vue';
  import UserCard from './UserProfile/UserCard.vue';

  export default {
    components: {
      EditProfileForm,
      UserCard
    },
    data () {
      return {
        userId: null,
        admin: false,
        loading: true,
        error: false
      }
    },
    computed: {
      company() {
        //return this.$store.state.companies.current;
        return ''
      },
      users() {
        return this.$store.state.current.all;
      },
      user() {
        //if(!isNaN(this.userId) && this.$store.getters.userIsAdmin){
          return this.$store.state.users.edit;
        //}
      }
    },
    created() {
      this.userId = this.$route.params.id;
      const { dispatch } = this.$store;
      dispatch("users/getById", this.userId);
    }
  }
</script>
